import { Getters } from 'vuex-smart-module';
import RepairsInfoState from './state';

export default class RepairsInfoGetters extends Getters<RepairsInfoState> {}
